import {round} from "./round"
import {HslaColor, HsvaColor, RgbaColor, RgbColor} from "../types"

export const hsvaToHsla = ({h, s, v, a}: HsvaColor): HslaColor => {
    const hh = ((200 - s) * v) / 100

    return {
        h: round(h),
        s: round(hh > 0 && hh < 200 ? ((s * v) / 100 / (hh <= 100 ? hh : 200 - hh)) * 100 : 0),
        l: round(hh / 2),
        a: round(a, 2)
    }
}

export const hsvaToHslString = (hsva: HsvaColor): string => {
    let {h, s, l} = hsvaToHsla(hsva)
    if (h >= 330){
        h = 0
        s = 0
        l = 100
        return `hsl(${h}, ${s}%, ${l}%)`
    }
    return `hsl(${h}, ${s}%, ${l}%)`
}

const DEFAULT_SATURATION = 100
const DEFAULT_V = 100
const DEFAULT_ALPHA = 1

export const hsvaToRgba = ({h, s, v, a}: HsvaColor): RgbaColor => {

    s = DEFAULT_SATURATION
    v = DEFAULT_V
    a = DEFAULT_ALPHA

    if (h >= 330){
        h = (h / 340) * 6
        s = 0
        v = 100
        return {
        r: 255,
        g: 255,
        b: 255,
        a: round(a, 2)
    }
    }else {
        h = (h / 340) * 6
        s = s / 100
        v = v / 100
    }

    const hh = Math.floor(h),
        b = v * (1 - s),
        c = v * (1 - (h - hh) * s),
        d = v * (1 - (1 - h + hh) * s),
        module = hh % 6

    return {
        r: round([v, c, b, b, d, v][module] * 255),
        g: round([d, v, v, c, b, b][module] * 255),
        b: round([b, b, d, v, v, c][module] * 255),
        a: round(a, 2)
    }
}


export const rgbaToHsva = ({r, g, b, a}: RgbaColor): HsvaColor => {
    const max = Math.max(r, g, b)
    const delta = max - Math.min(r, g, b)

    const hh = delta
        ? max === r
            ? (g - b) / delta
            : max === g
                ? 2 + (b - r) / delta
                : 4 + (r - g) / delta
        : 0

    return {
        h: round(60 * (hh < 0 ? hh + 6 : hh)),
        s: round(max ? (delta / max) * 100 : 0),
        v: round((max / 255) * 100),
        a
    }
}

const componentToHex = (c) => {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}

export const rgbToHex = ({r, g, b} : RgbColor): string => {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export const rgbaToRgb = ({r, g, b}: RgbaColor): RgbColor => ({r, g, b})
